import { render, staticRenderFns } from "./a-footer.vue?vue&type=template&id=3b9cfa42&"
import script from "./a-footer.vue?vue&type=script&lang=js&"
export * from "./a-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports